import logoColor from "./Logotipo-color.png";


export const IMG = {
    logoColor
}